import Config from './config/production.js'

import EventCalendar from './eventCalendar.js'
import EventDateBooking from './eventDateBooking.js'
import EventBook from './eventBook.js'
import Event from './event.js'
import Subscription from './subscription.js'
import Setting from './setting.js'
import VirtualEvent from './virtualEvent.js'
import Season from './season.js'
import SeasonCart from './seasonCart.js'
import FormTemplate from './formTemplate.js'
import Contract from './contract.js'
import EventDate from './eventDate.js'
import ProductOption from './productOption.js'
import Reminder from './reminder.js'

export default {
    Config,
    EventCalendar,
    EventDateBooking,
    Event,
    Subscription,
    Setting,
    EventBook,
    VirtualEvent,
    Season,
    SeasonCart,
    FormTemplate,
    Contract,
    EventDate,
    ProductOption,
    Reminder
}